import { createFileRoute } from "@tanstack/react-router";
import { PVP } from "@/pvp/components/PVP";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserApplications } from "@/pvp/components/UserApplications";
import { useState } from "react";

export const Route = createFileRoute("/_auth/pvp/")({
  component: PVPRoute,
});

function PVPRoute() {
  const [activeTab, setActiveTab] = useState("pvp");
  const [selectedPvpId, setSelectedPvpId] = useState<string | undefined>();

  return (
    <>
      <PageHeader title="Certifications" subtitle="Manage your applications for Low Carbon Technologies' cattle certifications." />
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full bg-white">
        <TabsList className="bg-white">
          <TabsTrigger value="pvp">Certifications</TabsTrigger>
          <TabsTrigger value="application">My Applications</TabsTrigger>
        </TabsList>
        <TabsContent value="pvp">
          <PVP
            onViewApplications={(pvpId) => {
              setSelectedPvpId(pvpId);
              setActiveTab("application");
            }}
          />
        </TabsContent>
        <TabsContent value="application">
          <UserApplications pvpId={selectedPvpId} />
        </TabsContent>
      </Tabs>
    </>
  );
}
